import { render, staticRenderFns } from "./LegacyAlertConfig.vue?vue&type=template&id=784e44d5"
import script from "./LegacyAlertConfig.vue?vue&type=script&lang=js"
export * from "./LegacyAlertConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports